var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex justify-center align-center"},[_c('v-switch',{staticClass:"ma-0 pa-0",attrs:{"loading":_vm.saving,"dense":"","hide-details":""},on:{"change":_vm.toggle},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }